export { default as isLanguage } from "./isLanguage";
